import { render, staticRenderFns } from "./UiPhotoSwipe.vue?vue&type=template&id=504ac1d7&scoped=true&"
import script from "./UiPhotoSwipe.vue?vue&type=script&lang=js&"
export * from "./UiPhotoSwipe.vue?vue&type=script&lang=js&"
import style0 from "./UiPhotoSwipe.vue?vue&type=style&index=0&id=504ac1d7&prod&scoped=true&lang=css&"
import style1 from "./UiPhotoSwipe.vue?vue&type=style&index=1&id=504ac1d7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504ac1d7",
  null
  
)

export default component.exports